// Has anyone signed in to the app on this phone? (ART-346) The signed-out first screen is the Welcome page only on a
// phone that has never been signed in; once someone has, logging out goes straight to Log in. A device fact, so it
// lives in the Keychain beside the session (the secure-storage plugin every build already carries — no new native
// code) and is never cleared by logout. On the web it is always "yes": the web never shows Welcome.
import { Capacitor } from "@capacitor/core";
import { SecureStoragePlugin } from "capacitor-secure-storage-plugin";

const KEY = "cntrl.signed_in_on_device";

/** True on the web, and on a phone where someone has signed in before. */
export async function hasSignedInOnThisDevice(): Promise<boolean> {
  if (!Capacitor.isNativePlatform()) return true;
  try {
    const { value } = await SecureStoragePlugin.get({ key: KEY });
    return value === "1";
  } catch {
    // The plugin REJECTS a missing key, which is the first-launch case, so any failure reads as "never signed in":
    // the worst it costs is the Welcome page once more, with Log in one tap away.
    return false;
  }
}

/** Remember that someone has signed in on this phone. Best effort; a failure only means Welcome shows again. */
export async function markSignedInOnThisDevice(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await SecureStoragePlugin.set({ key: KEY, value: "1" });
  } catch {
    /* best effort */
  }
}
